import { useParams } from "react-router-dom";
import MyFormik from "../../components/Form/MyFormik.tsx";
import { useGet } from "../../components/Fetch/useFetch.tsx";
import url from "../../module/fetch.tsx";
import RoleUtilisateur, {
  getInitialValues,
  prepareVariables,
  validationSchema,
} from "./RoleUtilisateur.tsx";

const UpdateRoleUtilisateur = () => {
  const { utilisateurId } = useParams();

  const utilisateurRoleState = useGet(url`/api/utilisateurs/${utilisateurId}`);

  if (!utilisateurRoleState.isResolved) {
    return;
  }

  const { data } = utilisateurRoleState;

  return (
    <MyFormik
      initialValues={getInitialValues(data)}
      validationSchema={validationSchema}
      isPost={true}
      submitUrl={`/api/utilisateurs/${utilisateurId}`}
      prepareVariables={(values) => prepareVariables(data, values)}
    >
      <RoleUtilisateur isNew={false} />
    </MyFormik>
  );
};

export default UpdateRoleUtilisateur;
